import Tooltip from "components/atoms/Tooltip";
import BatchProcessResult from "components/molecules/BatchProcessResult";
import DataTable from "components/molecules/DataTable";
import moment from "moment";
import CypressTestIds from "../../../cypress/CypressTestIds";

const DataObjectJobRecentList = ({ jobList }) => {
    return (
        <DataTable
            dataTestId={CypressTestIds.RECENT_LIST_JOBS_TABLE}
            hideSelectionColumn
            fixedHeader
            tableProps={{
                size: "small",
                rowKey: "jobId",
                dataSource: jobList,
                pagination: false,
                columns: [
                    {
                        width: "15%",
                        dataIndex: "dataSetName",
                        title: "Dataset",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, job, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        width: "12%",
                        dataIndex: "businessAreaName",
                        title: "Business Area",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, job, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value}
                            </Tooltip>
                        ),
                    },
                    {
                        width: "10%",
                        dataIndex: "status",
                        title: "Run Status",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, job, index) => {
                            let color = "#5C5B5B";
                            switch (value) {
                                case "COMPLETED":
                                    color = "#11A400";
                                    break;
                                case "FAILED":
                                case "CANCELLING":
                                case "CANCELLED":
                                    color = "#FF0000";
                                    break;
                                case "RUNNING":
                                case "PENDING":
                                    color = "#1F81FF";
                                    break;
                                default:
                                    break;
                            }
                            let statusText = value;
                            if (job.undo) {
                                if (job.jobType === "FIND_DATA_OBJECTS_DUPLICATES") {
                                    statusText = `DELETE ${statusText}`;
                                } else {
                                    statusText = `UNDO ${statusText}`;
                                }
                            }
                            return (
                                <Tooltip placement="topLeft" title={statusText}>
                                    <span style={{ color: color }}>{statusText}</span>
                                </Tooltip>
                            );
                        },
                    },
                    {
                        width: "auto",
                        dataIndex: "runInfo",
                        title: "Progress",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, job, index) => {
                            if (value) {
                                return (
                                    <Tooltip placement="topLeft">
                                        <BatchProcessResult batchProcessResult={value} textMaxWidth="12rem" onBatchOperationClick={(item) => {}}></BatchProcessResult>
                                    </Tooltip>
                                );
                            }
                            // Show progress text for pipeline execution jobs
                            if (job.jobType === "PIPELINE_EXECUTION") {
                                const recordCount = job.runInfo?.rowsProcessed || job.recordCount || 0;
                                const text = job.status === "COMPLETED"
                                    ? `Transformed ${recordCount.toLocaleString()} records`
                                    : job.status === "RUNNING"
                                        ? "Transforming..."
                                        : job.status === "FAILED"
                                            ? "Transform failed"
                                            : "Pending";
                                return (
                                    <Tooltip placement="topLeft" title={text}>
                                        <span>{text}</span>
                                    </Tooltip>
                                );
                            }
                            return <></>;
                        },
                    },
                    {
                        width: "15%",
                        dataIndex: "startedDate",
                        title: "Started DateTime",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, job, index) => {
                            let displayValue = null;
                            if (value) {
                                displayValue = moment.utc(value).toDate().toLocaleString();
                                return (
                                    <Tooltip placement="topLeft" title={displayValue}>
                                        {displayValue}
                                    </Tooltip>
                                );
                            }
                            return <></>;
                        },
                    },
                    {
                        width: "15%",
                        title: "Running Duration",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (job) => {
                            if (job.startedDate && job.completedDate) {
                                let startDate = moment.utc(job.startedDate);
                                let completedDate = moment.utc(job.completedDate);
                                let duration = moment.duration(completedDate.diff(startDate));
                                let displayValue = moment.utc(duration.as("milliseconds")).format("HH:mm:ss");
                                return (
                                    <Tooltip placement="topLeft" title={displayValue}>
                                        {displayValue}
                                    </Tooltip>
                                );
                            }
                            return <></>;
                        },
                    },
                    {
                        width: "20%",
                        dataIndex: "createdByEmail",
                        title: "Job Owner",
                        ellipsis: {
                            showTitle: false,
                        },
                        render: (value, job, index) => (
                            <Tooltip placement="topLeft" title={value}>
                                {value || job.createdBy}
                            </Tooltip>
                        ),
                    },
                ],
            }}
        ></DataTable>
    );
};

export default DataObjectJobRecentList;
